// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"639":"623aecf1","657":"1b249599","868":"dd2064dd"}[chunkId] + ".css";
};